import { makeAutoObservable } from "mobx";
import { GET, PATCH, POST, GET_USER } from "../apis/apis";
import { message } from "antd";

class UserStore {
  constructor({ errStore, textStore }) {
    makeAutoObservable(this);
    this.errStore = errStore;
    this.textStore = textStore;
  }

  token = localStorage.getItem("kc_token");
  user = null;
  isUserModalOpen = false;
  profileUser = null;
  userDetails = null;
  userRoleData = null;
  userRole = null;

  setUserDetails = (value) => {
    this.userDetails = value;
  };
  setProfileUser = (value) => {
    this.profileUser = value;
  };
  setUserRole = (value) => {
    this.userRole = value;
  };
  setUserRoleData = (value) => {
    this.userRoleData = value;
  };
  setIsUserModalOpen = (value) => {
    this.isUserModalOpen = value;
  };

  setUser = (value) => {
    this.user = value;
  };

  setToken = (value) => {
    this.token = value;
  };

  getToken = () => {
    this.token = localStorage.getItem("kc_token");
  };

  formUserDetails = [];
  reportedUser = [];
  setReportedUser = (value) => {
    this.reportedUser = value;
  };
  // user
  GetUser = () => {
    this.errStore.setLoading(true);
    GET_USER(`/user`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setUser(data);
        this.formUserDetails = [
          {
            name: "id",
            value: this.user.id,
          },
          {
            name: "bio",
            value: this.user.bio,
          },
          {
            name: "first_name",
            value: this.user.first_name,
          },
          {
            name: "last_name",
            value: this.user.last_name,
          },
          {
            name: "email",
            value: this.user.email,
          },
          {
            name: "external_link",
            value: this.user.external_link,
          },
        ];
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };
  GetUserRole = () => {
    this.errStore.setLoading(true);
    GET_USER(`/user/role`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setUserRoleData(data);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };
  UpdateUserProfile = (values) => {
    this.errStore.setLoading(true);
    PATCH(`/user`, values)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setUser(data);
        this.setIsUserModalOpen(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetUserByUsername = (username) => {
    this.errStore.setLoading(true);
    GET(`/user/username/${username}`)
      .then((data) => {
        this.errStore.setMessage("");
        this.setProfileUser(data);
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetUserDetails = (username) => {
    this.errStore.setLoading(true);
    GET(`/user/username/${username}`)
      .then((data) => {
        this.errStore.setMessage("");
        this.setUserDetails(data);
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetUserById = (id) => {
    this.errStore.setLoading(true);
    GET(`/user/id/${id}`)
      .then((data) => {
        this.errStore.setMessage("");

        this.setReportedUser(data);
        console.log(this.reportedUser);
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetApprovalCheck = async (values) => {
    try {
      const response = await POST("/approval/check", values);

      if (response?.approval === true) {
        return true;
      } else if (response?.result === false) {
        const approved = await this.GetApproval(values);
        return approved;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  GetApproval = async (values) => {
    try {
      const data = await POST("/approval", values);

      const transactionObject = {
        from: data.from,
        data: data.data,
        to: data.to,
        value: data.value.toString(16),
      };

      try {
        await window.ethereum.request({
          method: "eth_sendTransaction",
          params: [transactionObject],
        });
        message.success("Transaction approved");
        return true;
      } catch (error) {
        message.error("Transaction declined");
        return false;
      }
    } catch (error) {
      const parsedData =
        typeof error.response?.data === "string"
          ? JSON.parse(error.response?.data.replace(/'/g, '"'))
          : error.response?.data;

      parsedData?.message
        ? message.error(parsedData.message)
        : message.error("An error occurred during the transaction");
      console.error(error);
      return false;
    }
  };
}

export default UserStore;
